import { StoryFinder } from '@novelist/novum-novella-ui';
import React, { useState, useEffect } from "react";
import AnalyticsWrapperContainer from './AnalyticsWrapperContainer';
import * as StoryMixerSelector from "../../data/StoryMixerSelector";
import { getOtsAvailabilityDataForTitles } from '../../data/OtsDataSelector';
import * as authorUtil from '../../lib/AuthorUtility';
import { getAvailabilityConfiguration } from '../../data/DataStore';
import * as catalogUtils from '../../lib/CatalogLinkUtilities';

const translateToNovumData = (data) => {
	return {
		titles: data.Titles.map((item) => {
			return {
				ui: item.ui,
				mainTitle: item.main_title,
				bookjacketUrl: item.bookjacket_url.url,
				catalogLinkUrl: item.is_held_locally === false ? null : catalogUtils.getTitleCatalogLink(item.links),
				isHeld: item.is_held_locally,
				author: authorUtil.formatAuthorName(item.author),
				availability: item.availability
			}
		}),
		summary: modifySummaryText(data.Summary),
		searchedTraits: data.Terms
	};
}

function modifySummaryText(summary) {
    return summary.split(':')[0] + ":";
}

const StoryFinderContainer = () => {
	const [storyFinderTerms, setStoryFinderTerms] = useState([]);
	const availabilityConfiguration = getAvailabilityConfiguration();

	useEffect(() => {
		StoryMixerSelector.getStoryMixerAppealTerms(callBackActionAppealTerms);
	}, []);

	const callBackActionAppealTerms = (data) => {
		setStoryFinderTerms(data.storyElements || []);
	}

	const otsPostAction = (titlesWithOts, callback, data) => {
		data.Titles = titlesWithOts;
		callback(translateToNovumData(data));
	}

	const titlesPostAction = (data, callback) => {
		if (data.OtsResultRelativeUrl) {
			getOtsAvailabilityDataForTitles((titlesWithOts) => { otsPostAction(titlesWithOts, callback, data) }, "StoryFinder", data.OtsResultRelativeUrl, data.Titles);
		} else {
			callback(translateToNovumData(data));
		}
	}

	const termHandleClick = (searchValues, callback) => {
		StoryMixerSelector.getTitlesBySelectedTermsforV4(searchValues, (data) => { titlesPostAction(data, callback) });
	}

	if (storyFinderTerms.length) {
		return (<AnalyticsWrapperContainer
			Component={<StoryFinder storyFinderTerms={storyFinderTerms} termHandleClick={termHandleClick} availabilityConfiguration={availabilityConfiguration} />}
			componentName={'Story Element'}
			featureType={'Story Elements'}
		/>);
	}
	else {
		return null;
	}
}

export default StoryFinderContainer;

export { translateToNovumData } 


// WEBPACK FOOTER //
// ./src/react/containers/StoryFinderContainer.jsx